import { render, staticRenderFns } from "./SwissDevJobs.vue?vue&type=template&id=88f3d40a&scoped=true"
import script from "./SwissDevJobs.vue?vue&type=script&lang=js"
export * from "./SwissDevJobs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88f3d40a",
  null
  
)

export default component.exports